import React from "react";
import ReactDOM from "react-dom";
import "regenerator-runtime/runtime";
import * as Flex from "@twilio/flex-ui";
import "./index.css";
import App from "./App";
import AppVersion from "./AppVersion";
import { unregisterServiceWorker } from "./serviceWorker";
import CustomTheme from './CustomTheme';

const mountNode = document.getElementById("root");

window.onload = () => {
  const predefinedConfig = window.appConfig || {};

  const configuration = {
    ...predefinedConfig,
    colorTheme: CustomTheme
  };

  console.log(`current app version: ${global.appVersion}`);

  Flex
    .progress(mountNode)
    .provideLoginInfo(configuration, mountNode)
    .then(() => Flex.Manager.create(configuration))
    .then(manager => {
      setupOutboundVoiceChannel(manager);
      addAppVersionToHeader();
      renderApp(manager);
    })
    .then()
    .catch(error => handleError(error));
};

function renderApp(manager) {
  ReactDOM.render(
    <App manager={manager} />,
    mountNode
  );
}

function setupOutboundVoiceChannel(manager) {
  manager.strings.TaskLineCallReserved = "Reserved {{task.attributes.direction}} call";
  
  const outboundVoiceChannel = Flex.DefaultTaskChannels.createCallTaskChannel("outboundVoice",
    (task) => task.taskChannelUniqueName === "voice" && task.attributes.direction === "outbound");

  outboundVoiceChannel.templates.IncomingTaskCanvas.titleLine = "Incoming outbound call";

  Flex.TaskChannels.register(outboundVoiceChannel);
}

function addAppVersionToHeader() {
  Flex.MainHeader.Content.add(<AppVersion key="globalAppVersion" />, { sortOrder: 1, align: "end" });
}

function handleError(error) {
  Flex.errorPage(error, mountNode);
  console.error("Failed to initialize Flex", error);
}

unregisterServiceWorker();
